// Dashboard themes — sidebar + accent color palettes (Slack/Bigin inspired)
export const DASHBOARD_THEMES = [
  { id: 'desky-green', name: 'Desky Green', sidebar: '#14532d', accent: '#34A853' },
  { id: 'ocean', name: 'Ocean', sidebar: '#0c2d48', accent: '#2e86de' },
  { id: 'aubergine', name: 'Aubergine', sidebar: '#3F0E40', accent: '#E01E5A' },
  { id: 'midnight', name: 'Midnight', sidebar: '#0f172a', accent: '#6366f1' },
  { id: 'sunset', name: 'Sunset', sidebar: '#431407', accent: '#f97316' },
  { id: 'teal', name: 'Teal', sidebar: '#042f2e', accent: '#14b8a6' },
  { id: 'charcoal', name: 'Charcoal', sidebar: '#18181b', accent: '#a1a1aa' },
  { id: 'ruby', name: 'Ruby', sidebar: '#450a0a', accent: '#ef4444' },
  { id: 'lavender', name: 'Lavender', sidebar: '#1e1b4b', accent: '#8b5cf6' },
  { id: 'slate', name: 'Slate', sidebar: '#1e293b', accent: '#64748b' },
  { id: 'coffee', name: 'Coffee', sidebar: '#1c1917', accent: '#d4a574' },
  { id: 'nord', name: 'Nord', sidebar: '#2e3440', accent: '#88c0d0' },
];

// Login page theme presets — bg + button + accent
export const LOGIN_THEMES = [
  { id: 'emerald', name: 'Emerald', bg_color: '#14532d', primary_color: '#34A853', accent_color: '#f97316' },
  { id: 'ocean', name: 'Ocean', bg_color: '#0c2d48', primary_color: '#2e86de', accent_color: '#60a5fa' },
  { id: 'berry', name: 'Berry', bg_color: '#3F0E40', primary_color: '#E01E5A', accent_color: '#ECB22E' },
  { id: 'midnight', name: 'Midnight', bg_color: '#0f172a', primary_color: '#6366f1', accent_color: '#a78bfa' },
  { id: 'sunset', name: 'Sunset', bg_color: '#431407', primary_color: '#f97316', accent_color: '#fbbf24' },
  { id: 'teal', name: 'Teal', bg_color: '#042f2e', primary_color: '#14b8a6', accent_color: '#2dd4bf' },
  { id: 'charcoal', name: 'Charcoal', bg_color: '#18181b', primary_color: '#71717a', accent_color: '#a1a1aa' },
  { id: 'ruby', name: 'Ruby', bg_color: '#450a0a', primary_color: '#ef4444', accent_color: '#fca5a5' },
  { id: 'lavender', name: 'Lavender', bg_color: '#1e1b4b', primary_color: '#8b5cf6', accent_color: '#c4b5fd' },
  { id: 'slate', name: 'Slate', bg_color: '#1e293b', primary_color: '#64748b', accent_color: '#94a3b8' },
];
